/**
 * Cookiebot is deferred in `_document`, so for a visitor who has already
 * consented `CookiebotOnAccept` fires before React hydrates and the listener in
 * `<Tracking>` never sees it — UET would stay on its `denied` default all
 * session and Microsoft would refuse to attribute the conversions. Call this
 * once the UET tag is on the page as well as from the accept listener.
 */
export const grantUETConsent = () => {
  if (!window.Cookiebot?.consent?.marketing) {
    return;
  }

  window.uetq = window.uetq ?? [];

  window.uetq.push('consent', 'update', {
    ad_storage: 'granted',
  });
};
